import React, { useEffect, useState } from 'react';
import '../styles/Celebration.css';
import celebrationCat from '../assets/celebration-cat.png';

const Celebration = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [canClose, setCanClose] = useState(false);

  useEffect(() => {
    // Her ayın 5'inde kutlama
    const checkDate = () => {
      const now = new Date();
      const day = now.getDate();
      
      // Test modu: URL'de ?celebrate=true varsa her zaman göster
      const urlParams = new URLSearchParams(window.location.search);
      const testMode = urlParams.get('celebrate') === 'true';
      
      if (day === 5 || testMode) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    checkDate();
    // Her saat kontrol et
    const interval = setInterval(checkDate, 1000 * 60 * 60);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!isVisible) return;
    // Prevent immediate close on initial touch/click
    setCanClose(false);
    const t = setTimeout(() => setCanClose(true), 300);
    return () => clearTimeout(t);
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div
      className="celebration-overlay"
      onClick={() => canClose && setIsVisible(false)}
      onTouchStart={() => canClose && setIsVisible(false)}
      role="button"
      aria-label="Kutlamayı kapat"
      tabIndex={-1}
    >
      <div className="celebration-backdrop" aria-hidden="true" />
      <div className="celebration-stage">
        <div className="celebration-content">
          <h1 className="celebration-title">
            Nice Aylarımız Nice Yıllarımız olsun Sevgilimm
          </h1>
          <p className="celebration-subtitle">
            Seni Her Şeyden Ve Herkesten Daha Çok Seviyorumm 💕
          </p>
          <img
            className="celebration-image"
            src={celebrationCat}
            alt=""
            aria-hidden="true"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
    </div>
  );
};

export default Celebration;
